import type { QueryClient } from '@tanstack/react-query';

/**
 * Invalidate the order query family so Order Detail panels stay in sync
 * (OrderedTabs, activity RHS/drawer, drawer, confirmation, quote modal).
 */
export const invalidateOrder = (queryClient: QueryClient, orderId: string) =>
    Promise.all([
        queryClient.invalidateQueries({ queryKey: ['/order/detail', orderId] }),
        queryClient.invalidateQueries({ queryKey: ['/order/activity-logs', orderId] }),
        queryClient.invalidateQueries({ queryKey: ['/order/drawer', orderId] }),
        queryClient.invalidateQueries({ queryKey: ['order-confirmation', orderId] }),
        queryClient.invalidateQueries({ queryKey: ['quoteData', orderId] }),
    ]);
